import { render, staticRenderFns } from "./SidebarRight.vue?vue&type=template&id=9e041896&scoped=true&"
import script from "./SidebarRight.vue?vue&type=script&lang=ts&"
export * from "./SidebarRight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e041896",
  null
  
)

export default component.exports